import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

// 本地存储 token 的键名
export const TOKEN_KEY = 'token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000
})

// 请求拦截器：自动携带 token
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器：统一处理返回结果与错误
service.interceptors.response.use(
  response => {
    const res = response.data

    // 如果是文件流等非标准结构，直接返回
    if (res instanceof Blob) {
      return res
    }

    // 约定后端返回结构 { code, msg, data }
    // 根据实际后端约定调整成功码
    if (res.code !== undefined && res.code !== 0 && res.code !== 200) {
      ElMessage.error(res.msg || '请求失败')

      // token 失效 / 未授权
      if (res.code === 401 || res.code === 403) {
        handleUnauthorized()
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    }

    return res
  },
  error => {
    const status = error.response && error.response.status
    if (status === 401 || status === 403) {
      handleUnauthorized()
    }
    const msg =
      (error.response && error.response.data && error.response.data.msg) ||
      error.message ||
      '网络异常，请稍后重试'
    ElMessage.error(msg)
    return Promise.reject(error)
  }
)

function handleUnauthorized() {
  removeToken()
  if (router.currentRoute.value.path !== '/login') {
    router.push('/login')
  }
}

export default service
